import SettingsMenuGroup from "./SettingsMenuGroup";
import SettingsMenuRow from "./SettingsMenuRow";

export default function SettingsMenuScreen({
  eyebrow,
  title,
  description,
  showTitle = true,
  groups,
  items,
  itemStateMap = {},
  onSelect,
  showIcons = true,
}) {
  return (
    <div className="space-y-5">
      {showTitle ? (
        <div>
          {eyebrow ? <p className="lz-settings-header__eyebrow">{eyebrow}</p> : null}
          {title ? <h2 className="lz-settings-header__title">{title}</h2> : null}
          {description ? <p className="lz-settings-hint">{description}</p> : null}
        </div>
      ) : description ? (
        <p className="lz-settings-hint">{description}</p>
      ) : null}

      {Array.isArray(groups) && groups.length > 0 ? (
        <div className="space-y-5">
          {groups.map((group) => (
            <SettingsMenuGroup
              key={group.label}
              label={group.label}
              items={group.items}
              itemStateMap={itemStateMap}
              onSelect={onSelect}
              showIcons={showIcons}
            />
          ))}
        </div>
      ) : (
        <div className="lz-settings-group__rows">
          {items.map((item, index) => {
            const state = itemStateMap[item.id] || {};

            return (
              <SettingsMenuRow
                key={item.id}
                label={item.label}
                description={item.menuDescription ?? item.description}
                icon={item.icon}
                showIcon={showIcons}
                badge={state.badge}
                meta={state.meta}
                showSeparator={index > 0}
                onClick={() => onSelect(item)}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}
